import React from 'react';

import ListSelect from '../generic/ListSelect';
import { FILTER_TYPES } from '../generic/Table/utils';
import { MerchantLinks } from '../merchants/Link';
import { boolColumnWithFilter, simpleColumn } from '../utils/column-helpers';
import { brandLinks, email, lastName } from '../utils/columns';
import ContactLink from './ContactLink';
import ContactStatus from './ContactStatus';

export { brandLinks };

export const firstName = simpleColumn('First Name', 'firstName', 100); // prettier-ignore
export const     title = simpleColumn('Title',      'title'         ); // prettier-ignore

export const zDirectUser = boolColumnWithFilter(
  'zDirect User',
  'isZDirectUser',
  100,
);

export const lastNameLink = {
  Header: 'Last Name',
  accessor: 'lastName',
  Cell: row => <ContactLink lastNameOnly model={row.original} />,
};

export const status = {
  Header: 'Status',
  id: 'status',
  accessor: 'status',
  width: 100,
  Cell: row => (
    <div className="d-flex align-items-center">
      <ContactStatus status={row.value} />
    </div>
  ),
  filterCriteria: FILTER_TYPES.STARTS_WITH,
};

export const merchantLinks = {
  Header: 'Merchant',
  id: 'merchant',
  accessor: 'merchants',
  Cell: row => <MerchantLinks models={row.value} />,
  Filter: props => <ListSelect {...props} type="allZmsamMerchant" />,
  filterCriteria: FILTER_TYPES.LIST_SELECT,
  filterKey: 'merchantId',
  sortKey: 'merchants__id',
};

export const salesforceId = simpleColumn('Salesforce ID', 'salesforceId', 100);

export const salesforceContact = boolColumnWithFilter(
  'Salesforce contact',
  'isSalesforceContact',
  120,
);

export const listColumns = [
  firstName,
  lastNameLink,
  email,
  title,
  zDirectUser,
  status,
  merchantLinks,
  salesforceId,
  salesforceContact,
];
export const selectColumns = [
  firstName,
  lastName,
  email,
  title,
  status,
  merchantLinks,
];
export const addToListColumns = [
  firstName,
  lastName,
  email,
  brandLinks,
  merchantLinks,
];
